
import breakpointMixin from '~/mixins/breakpoints'
import StoryblokComponent from '~/components/Storyblok/Component'

export default {
  components: { StoryblokComponent },
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.flexDirection = this.getBreakpointValue(this.blok?.flexDirection)
      styles.justifyContent = this.getBreakpointValue(this.blok?.justifyContent)
      styles.alignItems = this.getBreakpointValue(this.blok?.alignItems)
      styles.placeSelf = this.getBreakpointValue(this.blok?.placeSelf)
      styles.padding = this.getBreakpointValue(this.blok?.padding)
      styles.margin = this.getBreakpointValue(this.blok?.margin)

      return styles
    },
  },
}
